<ds-alert-modal
  [config]="modalConfig"
  (primaryEvent)="deleteConfirmEvent.emit()"
  (tertiaryEvent)="closeModal()"
></ds-alert-modal>
